var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      {
        staticClass: "card-header p-0",
        attrs: { id: "headingLayerResources" },
      },
      [
        _c(
          "a",
          {
            staticClass: "btn btn-block text-left p-3",
            attrs: {
              "data-toggle": "collapse",
              role: "button",
              href: "#collapseLayerResources",
              "aria-expanded": "false",
              "aria-controls": "collapseLayerResources",
            },
          },
          [
            _c("h6", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.title`))),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "collapse",
        attrs: {
          id: "collapseLayerResources",
          "aria-labelledby": "headingLayerResources",
          "data-parent": "",
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            !_vm.readonlyForm
              ? _c(
                  "div",
                  {
                    staticClass: "order-2 order-sm-1 col-12 col-sm-7 col-lg-6",
                  },
                  [
                    _c("TableData", {
                      ref: "tblResources",
                      attrs: {
                        simplified: true,
                        showTitleData: false,
                        tableWrapperClass: "py-2 px-1",
                        startLoad: _vm.startLoadResources,
                        route: _vm.prepareUrl(_vm.url.getResources),
                        settings: _vm.table.settings,
                        columns: _vm.table.columns,
                        inlineFilters: _vm.table.filters,
                        autoUpdateFilter: _vm.table.autoUpdateFilter,
                        externalFilters: _vm.tblFilters,
                        autoUpdateExternalFilter:
                          _vm.table.autoUpdateExternalFilter,
                        addParamsToUrl: _vm.table.addParamsToUrl,
                        loadingMsg: _vm.table.loadingMsg,
                        notFoundMsg: _vm.table.notFoundMsg,
                        orderByTemplate: _vm.table.orderByTemplate,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "filters",
                            fn: function ({ tableFilters, search }) {
                              return [
                                _c(
                                  "form",
                                  {
                                    attrs: { autocomplete: "false" },
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return search.apply(null, arguments)
                                      },
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return search.apply(null, arguments)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row header" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-12" },
                                        [
                                          _c("HeaderList", {
                                            attrs: {
                                              title: null,
                                              headerClass: "mb-3",
                                            },
                                            model: {
                                              value: tableFilters.q,
                                              callback: function ($$v) {
                                                _vm.$set(tableFilters, "q", $$v)
                                              },
                                              expression: "tableFilters.q",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "body",
                            fn: function ({ row, index, remove }) {
                              return [
                                _c(
                                  "td",
                                  { class: _vm.table.columns[0].class },
                                  [
                                    _c("ResourceItemList", {
                                      attrs: {
                                        value: row,
                                        enableCrossResource:
                                          _vm.enableCrossresources,
                                        readonlyForm: _vm.readonlyForm,
                                      },
                                      on: {
                                        addResource: function ($event) {
                                          return _vm.addResource(
                                            row,
                                            index,
                                            remove
                                          )
                                        },
                                        addCrossResource: function ($event) {
                                          return _vm.addCrossResource(
                                            row,
                                            index
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2917727150
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "order-1 order-sm-2 col-12 col-sm-5 col-lg-6" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "d-flex justify-content-between justify-content-md-start align-items-center",
                        },
                        [
                          _c("span", { staticClass: "text-muted pr-md-4" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  `${_vm.modelTranslateID}.resources_title`
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "badge badge-secondary badge-pill" },
                            [_vm._v(_vm._s(_vm.form.resources.length))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group city-form-group" },
                        [
                          !_vm.readonlyForm
                            ? _c("HelpSpan", {
                                attrs: {
                                  helpText: `${_vm.modelTranslateID}.resources_layers`,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.fnHasError("resources")
                            ? _c(
                                "small",
                                { staticClass: "invalid-feedback d-block" },
                                [_vm._v(_vm._s(_vm.fnFirstError("resources")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        _vm._b(
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, length: 1 },
                                expression: "{required: true, length: 1}",
                              },
                            ],
                            attrs: {
                              tag: "div",
                              draggable: ".list-group-item",
                              name: "resources",
                            },
                            on: { start: _vm.onDragStart, end: _vm.onDragEnd },
                            model: {
                              value: _vm.form.resources,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "resources", $$v)
                              },
                              expression: "form.resources",
                            },
                          },
                          "draggable",
                          _vm.dragOptions,
                          false
                        ),
                        [
                          _c(
                            "transition-group",
                            {
                              directives: [
                                { name: "validate", rawName: "v-validate" },
                              ],
                              staticClass: "p-0",
                              attrs: {
                                tag: "ul",
                                type: "transition",
                                name: !_vm.drag ? "flip-list" : null,
                              },
                            },
                            _vm._l(_vm.form.resources, function (element, idx) {
                              return _c(
                                "li",
                                {
                                  key: element.id,
                                  staticClass:
                                    "list-group-item p-0 border-0 cursor-default",
                                },
                                [
                                  _c("ResourceItemSelected", {
                                    attrs: {
                                      value: element,
                                      readonlyForm: _vm.readonlyForm,
                                      pivotKey: _vm.pivotResources,
                                    },
                                    on: {
                                      removeResource: function ($event) {
                                        return _vm.removeResource(idx)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }